import PropTypes from 'prop-types';
import React from 'react';
import ModuleTitle from '../../module/module_title';
import MediaQuery from '../../common/media_query';
import Link from 'react-router/lib/Link';
import Slider from 'react-slick';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import {get, map} from 'lodash';

const SLIDER_PROPS = {
  className: 'carousel-reviews',
  infinite: true,
  dots: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  initialSlide: 0,
  centerMode: true,
  draggable: true,
  variableWidth: false,
  lazyLoad: false,
  speed: 1000,
  touchThreshold: 30,
  touchMove: false,
  centerPadding: 0,
  autoplay: false,
  arrows: true
};

export function ProductReview({ title, text, contributor }) {
  return (
    <div className="review">
      <div className="review-left">
        <div className="quote-before">{'“'}</div>
        <p className="title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className="quote-after">{'"'}</div>
        {contributor ? (
          <div className="contributor">
            <img src={get(contributor, 'image.url')} />
            <div>
              <Link className="name"
                to={`/author/${contributor.slug}`}
                dangerouslySetInnerHTML={{ __html: contributor.name }}
              />
              <span className="type"
                dangerouslySetInnerHTML={{ __html: contributor.type }}
              />
            </div>
          </div>
        ) : (
          <div className="contributor">
            <div><span className="name">Anonymous</span></div>
          </div>
        )}
      </div>
      <div className="review-right">
        {contributor && (
          <RosettaFormattedMessage parentFilename={__filename}
            id="reviews_attribution"
            description="More from author link on desktop above product review"
            defaultMessage="More from"
          >
            { more_from => (
              <Link className="name"
                to={`/author/${contributor.slug}`}
                dangerouslySetInnerHTML={{ __html: `${more_from} ${contributor.name}` }}
              />
            )}
          </RosettaFormattedMessage>
        )}
        <p className="review-body"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  );
}

export default function ProductDetailsReviews(props) {
  const { reviews, page_type } = props;
  const renderedReviews = map(reviews, ({ id, ...props }) =>
    <ProductReview key={id} {...props} />
  );

  return (
    <div className="product-reviews">
      <RosettaFormattedMessage parentFilename={__filename}
        id="reviews_title"
        description="Title for the reviews section"
        defaultMessage="Reviews"
      >
        { review_title => <ModuleTitle title={review_title} page_type={page_type} /> }
      </RosettaFormattedMessage>
      <div className="reviews-wrapper">
        <MediaQuery breakpoint="notDesktop">
          {renderedReviews}
        </MediaQuery>
        <MediaQuery breakpoint="desktop">
          {
            reviews.length > 1
              ? <Slider {...SLIDER_PROPS}>
                {renderedReviews}
              </Slider>
              : <ProductReview {...reviews[0]} />
          }
        </MediaQuery>
      </div>
    </div>
  );
}

ProductDetailsReviews.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    text: PropTypes.string,
    contributor: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      slug: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  page_type: PropTypes.string
};

ProductReview.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  contributor: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    slug: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string
    })
  })
};
